module.exports = __webpack_public_path__ + "static/fonts/Mont-BlackItalic.f70ae4e.woff2";